import { render } from "./order-proposal-url-dialog.vue?vue&type=template&id=7d78267d&scoped=true&ts=true"
import script from "./order-proposal-url-dialog.vue?vue&type=script&lang=ts"
export * from "./order-proposal-url-dialog.vue?vue&type=script&lang=ts"

import "./order-proposal-url-dialog.vue?vue&type=style&index=0&id=7d78267d&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d78267d"]])

export default __exports__